export default {
  '/trainings/mytrainings/:id/lessons/:id/passing': 'routes_questions',
  '/trainings/mytrainings/:id/lessons/:id/results': 'routes_results',
  '/trainings/mytrainings/:id/lessons/:id/contents/text': 'routes_text',
  '/trainings/mytrainings/:id/lessons/:id/contents/link': 'routes_link',
  '/trainings/mytrainings/:id/lessons/:id/contents/audio': 'routes_audio',
  '/trainings/mytrainings/:id/lessons/:id/contents/video': 'routes_video',
  '/trainings/mytrainings/:id/lessons/:id/contents/image': 'routes_pictures',
  '/trainings/mytrainings/:id/lessons/:id/contents/document': 'routes_document',
  '/trainings/mytrainings/:id/lessons/:id/contents': 'routes_contents',
  '/trainings/mytrainings/:id/lessons/:id/pictures': 'routes_pictures',
  '/trainings/mytrainings/:id/lessons/:id/notes': 'routes_notes',
  '/trainings/mytrainings/:id/lessons/:id': 'routes_lesson',
  '/trainings/mytrainings/:id/start': 'routes_start',
  '/trainings/mytrainings/:id/finish': 'routes_finish',
  // '/trainings/mytrainings/:id/lessons': 'routes_lessons',
  '/trainings/mytrainings/:id/results': 'routes_results',
  '/trainings/mytrainings/:id/pictures': 'routes_pictures',
  '/trainings/mytrainings/:id/notes': 'routes_notes',
  '/trainings/mytrainings/:id/contents': 'routes_contents',
  '/trainings/mytrainings/:id': '',
  // '/trainings/mytrainings': 'routes_myTrainings',
  '/trainings/active': 'routes_active',
  '/trainings/inactive': 'routes_inactive',
  '/trainings/risk': 'routes_risk',
  '/trainings/inspection': 'routes_inspection',
  '/trainings/public': 'routes_public',
  '/trainings/chats/:id': '',
  '/trainings/chats': 'routes_chats',
  '/trainings/certificates': 'routes_certificates',
  '/trainings/pictures': 'routes_pictures',
  '/trainings/notes': 'routes_notes',
  '/trainings': 'routes_trainings',
  '/info/terms': 'header_info_companyTerms',
  '/info/service': 'header_info_servicePages',
  '/info/faq': 'header_info_FAQ',
  '/support': 'header_info_contactChat',
  '/change-password': 'header_profile_changePassword',
  '/profile': 'header_profile_profile',
};



// WEBPACK FOOTER //
// ./src/routes.js